import { createRouteRef } from "@backstage/frontend-plugin-api";

export const pluginId = "firefighter";

export const rootRouteRef = createRouteRef();
